// TreatmentDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import TreatmentForm from './TreatmentForm'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function TreatmentDialog({ model, setModel, targetType, target }) {
  const [submodel, setSubmodel] = useState()
  const [pollutantIDs]   = useState((Object.keys(model.POLLUTANTS).length===0?[]:Object.keys(model.POLLUTANTS)))
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    // Create a group of empty equations for each type of pollutant
    let TREATMENT = {[target]:{}}
    pollutantIDs.forEach((id) => 
      TREATMENT[target][id] = ""
    )

    // Overwrite empty equations with any existing equations.
    if(model.TREATMENT && model.TREATMENT[target]){
      TREATMENT = {
        [target]: {
          ...TREATMENT[target],
          ...model.TREATMENT[target]
        }
      }
    }

    setSubmodel({
      TREATMENT: TREATMENT
    })
  }, [])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    
    setModel(prev => ({
      ...prev,
      TREATMENT:{
        ...prev.TREATMENT, 
        [target]: {
          ...(cleanSub.TREATMENT[target])
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
              <label>Treatment for Node {target}</label>
            </div>
          </Typography>
          <div>
            <Button fullWidth onClick={saveEdits} >Save Edits</Button>
          </div>
          <div style={{height: "280px", background:'black', overflowY: 'scroll', paddingBottom:"120px"}}>
            {
              targetType && 
              targetType in model && 
              target &&
              <TreatmentForm model={submodel} setModel={setSubmodel} fullModel={model} target={target} />
            }
          </div>
          </>
        }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}